<script lang="ts" setup>
  function onBannerClick() {
    navigateTo('/challenge-friends');
  }

  const { handleGameClick } = useGameLauncher();

  const gameIds = [
    EGameId.MAX_SCARAB_PLINKO,
    EGameId.MOBILE_WARFARE,
    EGameId.MAX_PLOSION,
    EGameId.ESCAPE_THE_CIRCLE,
    EGameId.MULTIMINES,
    EGameId.DUEL_21,
  ];
  const gameList = computed(() => gameIds.map((gameId) => stores.games.getGameConfigById(gameId)).filter(Boolean));

  function onGameClick(game: IGameData) {
    if (stores.games.gameIsLaunching) return;
    handleGameClick(game);
  }
</script>

<template>
  <div
    class="contain-inline-size sidebar-container @container relative mr-5 top-[98px] z-10 shrink-0 transition-all duration-300 w-[300px] min-[1792px]:w-[352px]"
  >
    <div
      class="contain-strict fixed right-5 top-[98px] h-[calc(100vh-124px)] w-[300px] min-[1792px]:w-[352px] transition-all duration-200 rounded-md bg-white/5 backdrop-blur-[25px] p-4 overflow-auto"
    >
      <div class="relative cursor-pointer" @click="onBannerClick">
        <CoreImage
          alt=""
          class="w-full"
          format="webp"
          src="/images/side-banners/side-banner-caf.png"
          sizes="lg:268px xl:320px"
        />
        <div
          class="absolute top-0 flex flex-col items-start gap-8 px-4 pt-12 @[352px]:gap-[38px] @[352px]:px-[22px] @[352px]:pt-16 text-white font-barlow"
        >
          <p
            class="text-[40px] @[352px]:text-[50px] font-black leading-none uppercase [text-shadow:1px_2px_0_rgba(0,0,0,0.5)]"
          >
            Challenge Friends
          </p>
          <p class="text-xl @[352px]:text-2xl font-bold leading-snug tracking-wide max-w-[200px]">
            PRIVATE GAMES WITH
            <b class="font-black">INVITED GUESTS ONLY!</b>
          </p>
          <CoreButton color="green" class="pointer-events-none">
            <span class="uppercase text-white">Challenge Now</span>
          </CoreButton>
        </div>
      </div>

      <h4 class="mt-6 mb-4 font-inter text-lg font-semibold leading-none text-white">Most Popular Games</h4>

      <div v-if="gameList.length" class="grid grid-cols-3 items-center justify-center gap-2.5">
        <img
          v-for="game in gameList"
          :key="game.id"
          :src="game.imageMostPopular"
          :alt="`${game.title} icon`"
          role="button"
          :aria-label="`Open ${game.title} game`"
          class="aspect-square w-[100px] cursor-pointer hover:brightness-105 hover:-translate-y-0.5 transition-all duration-200"
          :class="{ grayscale: stores.games.gameIsLaunching }"
          @click="onGameClick(game)"
        />
      </div>
    </div>
  </div>
</template>
